export const faqAutocompleteOn = () => `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 11L12 14L9 11" fill="#403F42"/>
<path d="M15 11L12 14L9 11L15 11Z" stroke="#403F42" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
